module.exports = __webpack_public_path__ + "static/media/s_nor_03.2d9664d7.png";